import React from "react";
import { Navigate } from "react-router-dom";

import { useProfile } from "../hooks/index";

const AuthProtected = (props: any) => {
  // const { userProfile, loading } = useProfile();
  const token = localStorage.getItem("token");

  /*
    redirect is un-auth access protected routes via url
  */
  if (!token) {
    return (
      // <Navigate to={{ pathname: "/auth-login"}} />
      <Navigate to={{ pathname: "/landing-page" }} />
    );
  }

  return <>{props.children}</>;
};

export { AuthProtected };
